// extracted by mini-css-extract-plugin
export var fadeIn = "_br-0";